/**
 * HenniPenny brand constants — the single source of truth for the in-app surfaces
 * (the lockup wordmark, the footer, the home hero). Change these here and they
 * update everywhere.
 *
 * NOTE: the static <title> and the OG/meta tags in index.html carry the name +
 * description separately (HTML can't read these constants at build time), so keep
 * them in sync by hand.
 *
 * The name plays on Henny Penny / Chicken Little — the character who cried "the sky
 * is falling!" Our chicken doesn't panic: she puts on her glasses and MODELS the
 * sky. The wit is load-bearing; keep it.
 */
export const BRAND_NAME = 'HenniPenny';
export const BRAND_TAGLINE = 'NILM load-disaggregation evidence workbench';

/** Used verbatim on the home hero — the landing tagline, kept in sync. */
export const BRAND_MANIFESTO =
  "We don't assume the sky is falling. We model it. We predict it. We power what's next.";

/** The public landing (a separate GitHub-Pages site). Linked from the app footer. */
export const LANDING_URL = 'https://hennipenny.com';

/** The lab's shared writing workspace (the Evidence Foundry app wearing the
 * HenniPenny brand). The workbench is where you experiment; the writing desk
 * is where sealed runs become evidence behind claims — every header links
 * there so the two surfaces always point at each other. */
export const WRITING_DESK_URL = 'https://app.hennipenny.com';

/** Support / contact address shown in the footer. */
export const CONTACT_EMAIL = 'hello@hennipenny.com';
